<template>
    <div class="form-sales-project form-sales-land" v-if="salesCard != null">
        <div class="container">
            <div class="column-container" :class="{'toManyRequests' : toManySendingMsg}">
                <div class="col-left">
                    <div class="form-titles">
                        <h3>{{salesCard.project_shablon_fields.shablon_form_title}}</h3>
                        <span>{{salesCard.project_shablon_fields.shablon_form_desc}}</span>
                    </div>
                </div>
                <div class="col-right">
                    <form class="form_call">
                        <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                            <div class="form-group form-text">
                                <input type="text" name="name" class="form-control" :placeholder="salesCard.project_shablon_fields.shablon_form_name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                            </div>
                            <div class="form-group form-phone">
                                <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                            </div>
                            <VueRecaptcha
                                ref="recaptcha"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                :sitekey="salesGcap_siteKey"
                                size="invisible"
                            />
                            <div class="btn-send">
                                <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{salesCard.project_shablon_fields.shablon_form_btn}}</button>
                                <span class="error-message" v-show="errors.has('name') || errors.has('phone')">Заполните все поля</span>
                            </div>
                        </div>
                        <div class="successMessage" v-if="!formVisible">
                            <h3>Спасибо! Ваша заявка отправлена.</h3>
                        </div>
                    </form>
                </div>
                <div class="privacy-desc" v-if="projectHost != 'nurly-dala2' && formVisible" :class="{'privacy-desc-white' : projectHost == 'duman'}">
                    <p>
                        <span>{{ salesCard.project_shablon_fields.shablon_form_privacy_desc.one }}</span> 
                        «<span>{{ salesCard.project_shablon_fields.shablon_form_btn }}</span>» <br>
                        <span class="two">{{ salesCard.project_shablon_fields.shablon_form_privacy_desc.two }}</span>
                        <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ salesCard.project_shablon_fields.shablon_form_privacy_desc.word }}</a></span>
                        <span class="three">{{ salesCard.project_shablon_fields.shablon_form_privacy_desc.three }}</span>
                    </p>
                </div>
                <div class="to-many-requests-msg" v-if="toManySendingMsg">
                    <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                    <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                    <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import { VueRecaptcha } from 'vue-recaptcha';
    // import VueRecaptcha from 'vue-recaptcha';
    import {mapGetters} from 'vuex'
    export default {
        name: 'FormConsultLand',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                currentPhone: null,
                projectHost: window.host,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
            // VueRecaptcha,
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('formPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('formPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'norep': 'noreplay@' + window.host + '.bazis.kz',
                    'name': this.name,
                    'phone': this.phone,
                    'project' : this.saleItem.project_name.slug,
                    'city' : this.saleItem.city_name.name,
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('formPage_submissionCounter', submissionCounter);
                    localStorage.setItem('formPage_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'})
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            onCaptchaExpired() {
                console.log('capcha expired');
                // Handle expiration
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptcha.execute();
                        // this.sendInGoogleDoc(data, this.salesCard.city_name_sales.slug);
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            // sendData() {
            //     var querystring = require('querystring');
            //     var data = {
            //         'norep': 'noreplay@' + window.host + '.bazis.kz',
            //         'name': this.name,
            //         'phone': this.phone,
            //         'project' : this.saleItem.project_name.slug,
            //         'city' : this.saleItem.city_name.name,
            //         'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
            //     };
            //     // console.log(this.salesCard, 'asdasdasd')
            //     // console.log(data, 'form consult')
            //     // console.log(JSON.stringify(data));
            //     this.$validator.validate().then(result => {
            //         if(result) {
            //             console.log('all ok')
            //             this.$refs.recaptcha.execute();
            //             this.formVisible = false
            //             axios.post('https://sales.bazis.kz/server/form-call.php', querystring.stringify(data)).then(() => {
            //                 dataLayer.push({'event' : 'form_sent'})
            //             });
                        
            //             // this.sendInGoogleDoc(data, this.salesCard.city_name_sales.slug);
            //         } else {
            //             this.errorMsg = true;
            //             console.log('Form inputs with errors');
            //         }
            //     });
            // },
            sendInGoogleDoc(data, city) {
                const currentDate = new Date();
                const parseDate = currentDate.toLocaleDateString('en-GB');
                const astanaOffset = 6 * 60 * 60 * 1000; // UTC+6 is 6 hours ahead of UTC
                const astanaTime = new Date(currentDate.getTime() + astanaOffset).toISOString().slice(11, 19);
                // console.log(astanaTime, parseDate,  'asdasdasd');
                if (city == 'astana') {
                    // axios.post('https://docs.google.com/forms/d/e/1FAIpQLSdxDpid76ukWEsdSH8NHunJLMSM4WcKTQeu7X_ljtEwlTE3Hg/formResponse',
                    // {
                    //     "entry.1378118099" : parseDate,
                    //     "entry.1799791417" : astanaTime,
                    //     "entry.1437042498": data.name,
                    //     "entry.116433678": data.phone,
                    //     "entry.335158217": data.project,
                    //     "entry.1065722292" : 'Astana',
                    // });
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSeNkuBljZoPpcwhSytq7TJPhthl98_n8huzNivGUXNiOs7NLg/formResponse",
                        data: {
                            "entry.219817812" : parseDate,
                            "entry.446037946" : astanaTime,
                            "entry.2097238308": data.name,
                            "entry.696309298": data.phone,
                            "entry.2000048479": data.project,
                            "entry.1866237283" : 'Astana',
                        },
                        // headers: {
                        //     "Access-Control-Allow-Origin": "*",
                        //     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
                        // },
                        type: "GET",
                        dataType: "xml"
                    });
                }
            },
            closeForm() {
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 1000);
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-sales-land.scss';
    @import '@/styles/components/forms/forms-respond/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>